import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './../Transaction/Transactions.css';
import { CreateSearchBarWithPlaceHolder, CreateButton } from './../CommonObjects';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import { token, domain } from './../Security';
import { useTable, useSortBy } from 'react-table';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import AddCardIcon from '@mui/icons-material/AddCard';
import EditNoteIcon from '@mui/icons-material/EditNote';
import RecyclingIcon from '@mui/icons-material/Recycling';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import PreviewIcon from '@mui/icons-material/Preview';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { DynamicFilterBar } from '../../v2/components/filters/DynamicFilterBar';
import { useFilterManager } from '../../v2/hooks/useFilterManager';
import { FEATURES } from '../../config/features';

function PagibigLoan({ user, userAccess, isHideSideMenu }) {
  const [canFullView, setCanFullView] = useState(false);

  useEffect(() => {
    setCanFullView(userAccess?.isFullLoanAccess);
  }, [userAccess]);

  const [loadingRequest, setLoadingRequest] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const [loans, setLoans] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const apiUrl = domain + "/api/PagibigLoan";

  const [apiFilterPayload_main, setApiFilterPayload_main] = useState(null)
  const [additionalApiFilterPayload_main, setAdditionalApiFilterPayload_main] = useState(null)

  const fetchDataDynamicFilter = useCallback(async () => {
    const _data = {
      filters: apiFilterPayload_main
    }

    try {
      setLoadingRequest(true);
      const response = await axios.post(`${apiUrl}/get-all-data`, _data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      setLoans(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingRequest(false); // Set loading state to false after data fetching is complete
    }
  }, [apiUrl, apiFilterPayload_main]);
  const fetchDataDefault = useCallback(async () => {
    try {
      setLoadingRequest(true);
      const response = await axios.get(apiUrl + `/username/${user.username}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      setLoans(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingRequest(false); // Set loading state to false after data fetching is complete
    }
  }, [apiUrl, user]);
  const fetchData = useCallback(async () => {
    if(FEATURES.IS_DYNAMIC_FILTER){
      await fetchDataDynamicFilter();
    } else {
      await fetchDataDefault();
    }
  }, [fetchDataDynamicFilter, fetchDataDefault]);

  const [showSetting, setShowSetting] = useState(false);
  const settingRef = useRef(null);
  const buttonRef = useRef(null);

  const handleSetting = () => {
    setShowSetting(!showSetting);
  };

  useEffect(() => {
    var settingIcon = document.getElementById("setting-icon");

    if (showSetting) {
      //change the down icon to up
      settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
      settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
    } else {
      //change the up icon to down
      settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
      settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
    }

    const handleClickOutside = (event) => {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetting(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };


  }, [showSetting]);

  const generateDownloadTemplate = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet('Loans');

    const header = [
      'EmployeeId',
      'EmployeeName',
      'TotalLoan',
      'TotalDeduction',
    ];
    const headerRow = worksheet1.addRow(header);
    worksheet1.columns = [
      { key: 'employeeId', width: 30 },
      { key: 'employeeName', width: 30 },
      { key: 'totalLoan', width: 30 },
      { key: 'defaultDeduction', width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
    });

    const information = [
      {
        employeeId: '<EMP1234>',
        employeeName: '<DELA CRUZ, JUAN>',
        totalLoan: '<0.00>',
        defaultDeduction: '<0.00>',
      },
    ];

    information.forEach(info => {
      worksheet1.addRow(info);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Pagibig_Loan_Template.xlsx');
  }, []);

  const [showUploadForm, setShowUploadForm] = useState(false);
  const openUploadFormHandleClick = () => {
    setShowUploadForm(true);
  }
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  }

  const fetchDataForEmployee = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/single-data";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);

  const [uploadData, setUploadData] = useState([])
  const uploadEmployeeData = async (file) => {
    setLoadingRequest(true);
    const dataEmployee = await fetchDataForEmployee();

    function sanitizeValue(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return '';
      }
      return value;
    }
    function sanitizeValueInteger(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return 0;
      }
      return value;
    }
    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeeId) missing.push('Employee Id');

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = dataEmployee.find(employee => employee.employeeId === item.employeeId?.toString());
        if (!existingEmployee) {
          errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
        }

        if (!Number.isFinite(item.totalLoan)) {
          errorMessage += errorMessage.length > 0 ? ` Invalid value - Total Loan.` : `Invalid value - Total Loan. `;
        }

        if (!Number.isFinite(item.defaultDeduction)) {
          errorMessage += errorMessage.length > 0 ? ` Invalid value - Total Deduction.` : `Invalid value - Total Deduction. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(', ')}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      };

      const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

      let bulkData = [];

      informations.forEach(info => {
        let foundEmployee = null;

        foundEmployee = dataEmployee.find(data => data.employeeId.toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());

        // i will use the locations, employments etc. here below
        bulkData.push({
          employeeId: sanitizeValue(info.EmployeeId),
          employeeName: sanitizeValue(info.EmployeeName),
          employeePersonalInformationId: foundEmployee ?
            sanitizeValue(foundEmployee.id)
            :
            0,
          totalLoan: info.TotalLoan ?
            sanitizeValueInteger(info.TotalLoan)
            :
            0,
          defaultDeduction: info.TotalDeduction ?
            sanitizeValueInteger(info.TotalDeduction)
            :
            0,
        });
      });

      // Validate the bulk data
      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadData(sortedData)
    };

    setLoadingRequest(false);
    reader.readAsArrayBuffer(file);
  };
  function handleFileUpload(files) {
    if (!files || files.length === 0) {
      console.error('No files selected');
      return;
    }

    const file = files[0];
    uploadEmployeeData(file);
  }
  const handleFinalFileUpload = async (bulkData) => {
    setLoadingRequest(true);

    const apiUrl = `${domain}/api/PagibigLoan/upload`;

    try {
      await axios.post(apiUrl, bulkData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      await SetAuditTrail({
        setupArea: "Pagibig Loan",
        actionTaken: "upload",
        field: "Upload",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  }

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo TransactionInfo">
            <div className="employeesTab-header transaction-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Loans & Benefits >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Pagibig Loan"}</span>
              </div>
              <div className='row' style={{ justifyContent: "space-between", alignItems: "center" }}>
                <h3>Pagibig Loan</h3>
                <div style={{ width: "30%", textAlign: "right", display: canFullView ? "block" : "none" }}>
                  <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                    <SettingsIcon />
                    <KeyboardArrowDownIcon id="setting-icon" />
                  </button>
                  <div ref={settingRef}>
                    {showSetting &&
                      <SettingInit
                        generateDownloadTemplate={generateDownloadTemplate}
                        openUploadFormHandleClick={openUploadFormHandleClick}
                      />}
                  </div>

                </div>
              </div>
            </div>
            <div className="transaction-body">
              {
                canFullView ?
                  <InitPagibigLoan user={user}
                    loans={loans} setLoans={setLoans}
                    filterData={filterData} setFilterData={setFilterData}
                    fetchData={fetchData}
                    apiFilterPayload_main={apiFilterPayload_main} setApiFilterPayload_main={setApiFilterPayload_main}
                    additionalApiFilterPayload_main={additionalApiFilterPayload_main} setAdditionalApiFilterPayload_main={setAdditionalApiFilterPayload_main}
                  />
                  :
                  <InitHistoryLoanTable user={user} />
              }
            </div>
          </div>
        </div>
      </div>

      <UploadForm isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        data_temp={uploadData}
        setData_temp={setUploadData}
        handleFileUpload={handleFileUpload}
        handleFinalFileUpload={handleFinalFileUpload}
      >
      </UploadForm>

      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>

      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}
function InitPagibigLoan({ user,
  loans, setLoans,
  filterData, setFilterData,
  apiFilterPayload_main, setApiFilterPayload_main,
  additionalApiFilterPayload_main, setAdditionalApiFilterPayload_main,
  fetchData
}) {
  var header = [
    "Pagibig Loan Id",
    "Employee Id",
    "Employee",
    "Total Loan",
    "Total Balance",
    "Default Deduction",
    "Is Active?",
    "",
  ]
  var accessor = [
    "pagibigLoanRequestId",
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "pagibigLoanRequestTotalLoan",
    "totalBalance",
    "defaultDeduction",
    "isActive",
    "manage"
  ]
  // Dynamic Filter
  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    additionalApiFilterPayload,
    applyFilters,
    resetFilters,
    // getFiltersAsDetails
  } = useFilterManager(FEATURES.LOAN_FILTER);

  const [shouldGenerate, setShouldGenerate] = useState(false);
  
  const finalSubmit = () => {
      setShouldGenerate(true);
      applyFilters();
  };

  useEffect(() => {
      if (!shouldGenerate) return;

      setApiFilterPayload_main(apiFilterPayload)
      setAdditionalApiFilterPayload_main(additionalApiFilterPayload)
      setShouldGenerate(false);
  }, [
    setApiFilterPayload_main, setAdditionalApiFilterPayload_main,
    apiFilterPayload, additionalApiFilterPayload, shouldGenerate
  ]);
  //================================================================

  const [currentPage, setCurrentPage] = useState(1);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by employee");

  const [addRequestForm, setAddRequestForm] = useState(false);
  const [editRequestForm, setEditRequestForm] = useState(false);
  const [overwriteRequestForm, setOverwriteRequestForm] = useState(false);
  const [historyForm, setHistoryForm] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [loadingRequest, setLoadingRequest] = useState(false);
  //Add
  const [employee, setEmployee] = useState("");
  const [totalLoan, setTotalLoan] = useState("");
  const [totalBalance, setTotalBalance] = useState("");
  const [defaultDeduction, setDefaultDeduction] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [remarks, setRemarks] = useState(false);
  //old
  const [oldTotalBalance, setOldTotalBalance] = useState("");
  const [oldDefaultDeduction, setOldDefaultDeduction] = useState("");

  //Confirmations
  const [newRequestConfirmationForm, setNewRequestConfirmationForm] = useState(false);
  const [editRequestConfirmationForm, setEditRequestConfirmationForm] = useState(false);
  const [recalculateRequestConfirmationForm, setRecalculateRequestConfirmationForm] = useState(false);
  const [cancelRequestConfirmationForm, setCancelRequestConfirmationForm] = useState(false);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const apiUrl = domain + "/api/PagibigLoan";

  const fetchDataAllLoans = useCallback(async () => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      return response.data; // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
      return []
    }
  }, [apiUrl]);
  const fetchExistingLoanData = async (id) => {
    try {
      const response = await axios.get(apiUrl + `/request/existing/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      return false; // Return false in case of error
    }
  };
  const fetchRequestLoanData = async (id) => {
    try {
      const response = await axios.get(apiUrl + `/request/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };

  useEffect(() => {
    fetchData();

    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by employee")
        break;
      case 1:
        setSearchPlaceholder("Search by pagibig loan id")
        break;
      default:
        setSearchPlaceholder("Search by employee")
        break;
    }
  }, [filterDataIndex,
    fetchData
  ]);

  useEffect(() => {
    if (addRequestForm
      || editRequestForm
      || overwriteRequestForm
    ) {
      setEmployee(selectedData.employeePersonalInformationFullName);
      setTotalLoan(selectedData.pagibigLoanRequestTotalLoan);
      setTotalBalance(selectedData.totalBalance);
      setDefaultDeduction(selectedData.defaultDeduction);
      setIsActive(selectedData.isActive);

      setOldTotalBalance(selectedData.totalBalance);
      setOldDefaultDeduction(selectedData.defaultDeduction);

      // ADDED: Mode-specific IsActive handling
      if (addRequestForm) {
        setIsActive(true);
      } else {
        setIsActive(selectedData.isActive === true);
      }
    }
  }, [addRequestForm,
    editRequestForm,
    overwriteRequestForm,
    selectedData,
    setTotalLoan,
    setTotalBalance,
    setDefaultDeduction,
    setIsActive
  ]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const currentDate = new Date();
    var requestModel = [];

    setAddRequestForm(false);
    setLoadingRequest(true);

    const requestData = {
      employeePersonalInformationId: selectedData.employeePersonalInformationId,
      totalLoan: totalLoan,
      dateGranted: currentDate,
      dateCancelled: null,
      status: "Approved"
    };

    try {
      const response = await axios.post(apiUrl + `/request`, requestData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      requestModel = response.data;
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    }

    const data = {
      pagibigLoanRequestId: requestModel.id,
      employeePersonalInformationId: selectedData.employeePersonalInformationId,
      totalBalance: totalLoan,
      defaultDeduction: defaultDeduction,
      isActive: isActive,
      remarks: ""
    };

    const allLoans = await fetchDataAllLoans();
    const loanData = allLoans.find(loan => loan.employeePersonalInformationId === selectedData.employeePersonalInformationId);

    try {
      await axios.post(apiUrl + `/createorupdate/${loanData ? loanData.id : 0}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setAddRequestForm(false);
      await SetAuditTrail({
        setupArea: "Pagibig Loan",
        actionTaken: "insert",
        field: "Add",
        newValue: `${employee}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setTotalLoan("");
      setTotalBalance("");
      setDefaultDeduction("");
      setEmployee("");
      setIsActive(false);
      setSelectedData([]);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleUpdate = async (event) => {
    event.preventDefault();
    setEditRequestForm(false);

    const data = {
      pagibigLoanRequestId: selectedData.pagibigLoanRequestId,
      employeePersonalInformationId: selectedData.employeePersonalInformationId,
      totalBalance: totalBalance,
      defaultDeduction: defaultDeduction,
      isActive: isActive,
      remarks: ""
    };

    try {
      setLoadingRequest(true);
      await axios.post(apiUrl + `/createorupdate/${selectedData.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      // ADDED: Log entry if deactivating the loan
      if (!isActive) {
        const logData = {
          pagibigLoanRequestId: selectedData.pagibigLoanRequestId,
          employeePersonalInformationId: selectedData.employeePersonalInformationId,
          amount: selectedData.pagibigLoanRequestTotalLoan,
          processedDate: new Date(),
          userId: user.id,
          remarks: remarks || "Set to Inactive"
        };
        await axios.post(domain + "/api/PagibigLoan/log", logData, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
      }

      let auditInfo = [];

      if (data.totalBalance !== oldTotalBalance) {
        auditInfo.push({
          setupArea: "Pagibig Loan",
          actionTaken: "update",
          field: "Total Balance",
          newValue: `${data.totalBalance}`,
          oldValue: `${oldTotalBalance}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.defaultDeduction !== oldDefaultDeduction) {
        auditInfo.push({
          setupArea: "Pagibig Loan",
          actionTaken: "update",
          field: "Default Deduction",
          newValue: `${data.defaultDeduction}`,
          oldValue: `${oldDefaultDeduction}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      setEditRequestForm(false);
      await SetAuditTrailBulk({ data: auditInfo });
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);

      setTotalLoan("");
      setTotalBalance("");
      setDefaultDeduction("");
      setEmployee("");
      setIsActive(false);
      setSelectedData([]);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleRecalculate = async (event) => {
    event.preventDefault();
    setOverwriteRequestForm(false);

    const result = await fetchRequestLoanData(selectedData.pagibigLoanRequestId);

    setLoadingRequest(true);

    const recalcData = {
      employeePersonalInformationId: result.employeePersonalInformationId,
      totalLoan: result.totalLoan,
      dateGranted: result.dateGranted,
      dateCancelled: null,
      status: "Completed"
    };

    try {
      await axios.put(apiUrl + `/request/${result.id}`, recalcData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    }

    const currentDate = new Date();
    var requestModel = [];

    const requestData = {
      employeePersonalInformationId: selectedData.employeePersonalInformationId,
      totalLoan: totalLoan,
      dateGranted: currentDate,
      dateCancelled: null,
      status: "Approved"
    };

    try {
      const response = await axios.post(apiUrl + `/request`, requestData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      requestModel = response.data;
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    }

    const data = {
      pagibigLoanRequestId: requestModel.id,
      employeePersonalInformationId: selectedData.employeePersonalInformationId,
      totalBalance: totalLoan,
      defaultDeduction: defaultDeduction,
      isActive: isActive,
      remarks: ""
    };

    const allLoans = await fetchDataAllLoans();
    const loanData = allLoans.find(loan => loan.employeePersonalInformationId === selectedData.employeePersonalInformationId);

    try {
      await axios.post(apiUrl + `/createorupdate/${loanData.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setOverwriteRequestForm(false);
      await SetAuditTrail({
        setupArea: "Pagibig Loan",
        actionTaken: "recalculate",
        field: "Recalculate Loan",
        newValue: `${employee}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setTotalLoan("");
      setTotalBalance("");
      setDefaultDeduction("");
      setEmployee("");
      setIsActive(false);
      setSelectedData([]);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleCancel = async (event) => {
    event.preventDefault();
    const currentDate = new Date();
    const result = await fetchRequestLoanData(selectedData.pagibigLoanRequestId);

    setLoadingRequest(true);

    const requestData = {
      employeePersonalInformationId: result.employeePersonalInformationId,
      totalLoan: result.totalLoan,
      dateGranted: result.dateGranted,
      dateCancelled: currentDate,
      status: "Cancelled"
    };

    try {
      await axios.put(apiUrl + `/request/${result.id}`, requestData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    }

    const data = {
      pagibigLoanRequestId: selectedData.pagibigLoanRequestId,
      employeePersonalInformationId: selectedData.employeePersonalInformationId,
      totalBalance: 0,
      defaultDeduction: 0,
      remarks: ""
    };

    try {
      await axios.put(apiUrl + `/${selectedData.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      await SetAuditTrail({
        setupArea: "Pagibig Loan",
        actionTaken: "cancelled",
        field: "Cancel Loan",
        newValue: `${employee}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setTotalLoan("");
      setTotalBalance("");
      setDefaultDeduction("");
      setEmployee("");
      setSelectedData([]);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.pagibigLoanRequestId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        break;
    }

    res = filterData.filter((f) =>
          f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue) ||
          f.employeePersonalInformationEmployeeId.toLowerCase().startsWith(lowercaseValue)
        );

    setLoans(res);
  };

  const openAddRequestForm = async (data) => {
    const isLoanExisted = await fetchExistingLoanData(data.employeePersonalInformationId);

    if (isLoanExisted) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Employee has existing loan. Use recalculate instead.");
      return;
    }

    setAddRequestForm(true);
    setSelectedData(data);
  };
  const closeAddRequestForm = () => {
    setAddRequestForm(false);
  };
  const openEditRequestForm = async (data) => {
    const isLoanExisted = await fetchExistingLoanData(data.employeePersonalInformationId);

    if (!isLoanExisted) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("The employee does not have current loan.");
      return;
    }

    setEditRequestForm(true);
    setSelectedData(data);
  };
  const closeEditRequestForm = () => {
    setEditRequestForm(false);
  };
  const openOverwriteRequestForm = async (data) => {
    const isLoanExisted = await fetchExistingLoanData(data.employeePersonalInformationId);

    if (!isLoanExisted) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Re-calculation failed. Please create new request instead.");
      return;
    }

    setOverwriteRequestForm(true);
    setSelectedData(data);
  };
  const closeOverwriteRequestForm = () => {
    setOverwriteRequestForm(false);
  };

  const openNewRequestConfirmationForm = () => {
    setNewRequestConfirmationForm(true);
  }
  const closeNewRequestConfirmationForm = () => {
    setNewRequestConfirmationForm(false);
  };
  const openEditRequestConfirmationForm = () => {
    setEditRequestConfirmationForm(true);
  }
  const closeEditRequestConfirmationForm = () => {
    setEditRequestConfirmationForm(false);
  };
  const openRecalculateRequestConfirmationForm = () => {
    setRecalculateRequestConfirmationForm(true);
  }
  const closeRecalculateRequestConfirmationForm = () => {
    setRecalculateRequestConfirmationForm(false);
  };
  const openCancelRequestConfirmationForm = async (data) => {
    const result = await fetchRequestLoanData(data.pagibigLoanRequestId);

    if (!result) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No existing loans to be cancelled.");
      return;
    }

    if (result && result.pagibigLoanLogs.length > 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Unable to cancel loan. There is already transaction with this loan.");
      return;
    }

    setCancelRequestConfirmationForm(true);
    setSelectedData(data);
  }
  const closeCancelRequestConfirmationForm = () => {
    setCancelRequestConfirmationForm(false);
  };
  const openHistoryForm = (data) => {
    setHistoryForm(true);
    setSelectedData(data);
  };
  const closeHistoryForm = () => {
    setHistoryForm(false);
  };

  return (
    <>
      {FEATURES.IS_DYNAMIC_FILTER ?
        <div className="filters-payroll">
          <div className="mb-5">
            <div className="bg-white rounded-lg border border-gray-200 p-2">
              <span className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-4 block">Filter</span>
              <DynamicFilterBar
                requestedFilters={FEATURES.LOAN_FILTER}
                activeFilterState={activeFilterState}
                onFilterChange={onFilterChange}
                onApply={applyFilters}
                onClear={resetFilters}
                allowAll={true}
                showButtons={false}
              />
            </div>
            <div className="mt-5">
              {CreateButton(
                "",
                "generate row",
                (e) => finalSubmit(e),
                "GENERATE",
                RestartAltIcon
              )}
            </div>
          </div>
        </div>
      :
        <></>
      }
      <div className='hidden'>
      { FilterPagibig(setFilterDataIndex)}
      </div>
      <div className="transaction-body-top row" style={{ justifyContent: "space-between" }}>
        {CreateSearchBarWithPlaceHolder("", "transaction-search row", "transaction-search-icon", "transaction-search-input", (e) => handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
      </div>
      <div className="transaction-table container">
        <CreateTable
          dataList={loans}
          dataHeader={header}
          dataAccessor={accessor}
          addRequest={openAddRequestForm}
          editRequest={openEditRequestForm}
          overwriteRequest={openOverwriteRequestForm}
          deleteRequest={openCancelRequestConfirmationForm}
          viewRequest={openHistoryForm}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
      <AddRequestForm isOpen={addRequestForm}
        onClose={closeAddRequestForm}
        employee={employee}
        setEmployee={setEmployee}
        totalBalance={totalBalance}
        setTotalBalance={setTotalBalance}
        totalLoan={totalLoan}
        setTotalLoan={setTotalLoan}
        defaultDeduction={defaultDeduction}
        setDefaultDeduction={setDefaultDeduction}
        isActive={isActive}
        setIsActive={setIsActive}
        handleSubmit={openNewRequestConfirmationForm}
      >
      </AddRequestForm>
      <EditRequestForm isOpen={editRequestForm}
        onClose={closeEditRequestForm}
        employee={employee}
        setEmployee={setEmployee}
        totalBalance={totalBalance}
        setTotalBalance={setTotalBalance}
        totalLoan={totalLoan}
        setTotalLoan={setTotalLoan}
        defaultDeduction={defaultDeduction}
        setDefaultDeduction={setDefaultDeduction}
        isActive={isActive}
        setIsActive={setIsActive}
        remarks={remarks}
        setRemarks={setRemarks}
        handleSubmit={openEditRequestConfirmationForm}
      >
      </EditRequestForm>
      <OverwriteRequestForm isOpen={overwriteRequestForm}
        onClose={closeOverwriteRequestForm}
        employee={employee}
        setEmployee={setEmployee}
        totalBalance={totalBalance}
        setTotalBalance={setTotalBalance}
        totalLoan={totalLoan}
        setTotalLoan={setTotalLoan}
        defaultDeduction={defaultDeduction}
        setDefaultDeduction={setDefaultDeduction}
        isActive={isActive}
        setIsActive={setIsActive}
        handleSubmit={openRecalculateRequestConfirmationForm}
      >
      </OverwriteRequestForm>
      <NewRequestConfirmation isOpen={newRequestConfirmationForm}
        onClose={closeNewRequestConfirmationForm}
        submit={handleSubmit}
      >
      </NewRequestConfirmation>
      <EditRequestConfirmation isOpen={editRequestConfirmationForm}
        onClose={closeEditRequestConfirmationForm}
        submit={handleUpdate}
      >
      </EditRequestConfirmation>
      <RecalculateRequestConfirmation isOpen={recalculateRequestConfirmationForm}
        onClose={closeRecalculateRequestConfirmationForm}
        submit={handleRecalculate}
      >
      </RecalculateRequestConfirmation>
      <CancelRequestConfirmation isOpen={cancelRequestConfirmationForm}
        onClose={closeCancelRequestConfirmationForm}
        submit={handleCancel}
      >
      </CancelRequestConfirmation>
      <HistoryLoan isOpen={historyForm}
        onClose={closeHistoryForm}
        selectedData={selectedData}
      >
      </HistoryLoan>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </>
  )
}

function SettingInit({
  generateDownloadTemplate,
  openUploadFormHandleClick,
}) {
  return (
    <div id='payroll-setting' className="payroll-setting column">
      <div className="payroll-setting-item row" onClick={() => generateDownloadTemplate(false)}>
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
        Download Template
      </div>
      <div className="payroll-setting-item row" onClick={() => openUploadFormHandleClick()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
        Upload Loans
      </div>
    </div>
  )
}
function UploadForm({ isOpen,
  onClose,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload }
) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter(i => i.errors.length > 0)

      if (_errorData.length <= 0) {
        setHasNoError(true)
      } else {
        setHasNoError(false)
      }
    }
  }, [data_temp])

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files)
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles])

  const submit = (e) => {
    handleFinalFileUpload(data_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = [
    "Employee Id",
    "Employee Name",
    "Total Loan",
    "Total Deduction",
    "Error",
  ]
  var accessor = [
    "employeeId",
    "employeeName",
    "totalLoan",
    "defaultDeduction",
    "errors",
  ]

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Loans"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div className="popUp-body user-template-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

            </div>

            <div>
              <label htmlFor="fileInput" className='browse'>Browse...</label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: 'none' }}
              />
              <div
                id='drop-files-here'
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  padding: '20px',
                  marginTop: '10px',
                  textAlign: 'center',
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                    <button id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}>
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ?
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white" }}>
                      Data is valid.
                    </div>
                  </>
                  :
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white" }}>
                      Cannot upload with error.
                    </div>
                  </>
                }
                <div className='employeesTab-tab upload-preview-tab' style={{ marginTop: "10px" }}>
                  <div id="container1 table-uploads" className="employeesTab-table container">
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
                  {hasNoError && <button id="add-family"
                    className="save row"
                    onClick={(e) => submit(e)}
                    style={{ marginRight: "5px" }}>
                    UPLOAD
                  </button>}
                  <button id="add-family"
                    className="cancel row"
                    style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                    onClick={() => handleClose()}>
                    CANCEL
                  </button>
                </div>
              </>
            )
            }


          </div>
        )}
      </div>
    </>
  );
}
function CreateTableForUpload({ dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage, setCurrentPage,
}) {
  const itemsPerPage = 5;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                    ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                    : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
                className={row.original.error ? "error" : ""}
              >
                {row.cells.map((cell) => (
                  <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                  />
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "25px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "25px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "25px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "25px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) :
        <></>}
    </div>
  )
}
function SetInfoForUpload({ header,
  _cell,
}) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (data.photo) {
      const imageSrc = 'data:image/jpeg;base64,' + data.photo;

      return (
        <td>
          <img className="avatarImg" src={imageSrc} alt="" />
        </td>
      )
    }
    return (
      <td>
        <img className="avatarImg" src="images/sample.jpg" alt="" />
      </td>
    )
  }

  if (header === "Date Created"
  ) {
    if (!value) {
      return (
        <td>
        </td>
      );
    }

    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return (
        <td>
          null
        </td>
      );
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return (
      <td>
        {formattedDateFrom}
      </td>
    )
  }

  if (header === "Error"
  ) {
    return (
      <td>
        {value && (
          <p style={{ color: "red", margin: 0 }}>
            {value}
          </p>
        )}
      </td>
    );
  }

  if (header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === 'number';

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    if (!isNumber) {
      return (
        <td {..._cell.getCellProps()}> {
          _cell.render("Cell")
        }
        </td>
      )
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return (
      <td>
        {formattedNumber}
      </td>
    )
  }

  return (
    <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
  )
}
function FilterPagibig(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "PagibigLoanId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
        <option value="All">All</option>
        <option value="PagibigLoanId">Pagibig Loan Id</option>
      </select>
    </div>
  );
};
function AddRequestForm({
  isOpen,
  onClose,
  employee,
  setEmployee,
  totalBalance,
  setTotalBalance,
  totalLoan,
  setTotalLoan,
  defaultDeduction,
  setDefaultDeduction,
  isActive,
  setIsActive,
  handleSubmit }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!totalLoan || !defaultDeduction) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEmployee("");
    setTotalBalance("");
    setTotalLoan("");
    setDefaultDeduction("");
    setIsActive(false);
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add Loan Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    placeholder="Employee"
                    value={employee}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setEmployee(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Balance</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    type='number'
                    placeholder="Total Balance"
                    value={totalBalance}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setTotalBalance(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Loan</div>
                <div className="info-item-input">
                  <input
                    type='number'
                    placeholder="Total Loan"
                    value={totalLoan}
                    onChange={(e) => setTotalLoan(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !totalLoan && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Deduction</div>
                <div className="info-item-input">
                  <input
                    type='number'
                    placeholder="Total Deduction"
                    value={defaultDeduction}
                    onChange={(e) => setDefaultDeduction(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !defaultDeduction && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Active?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                ADD REQUEST
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditRequestForm({
  isOpen,
  onClose,
  employee,
  setEmployee,
  totalBalance,
  setTotalBalance,
  totalLoan,
  setTotalLoan,
  defaultDeduction,
  setDefaultDeduction,
  isActive,
  setIsActive,
  remarks,
  setRemarks,
  handleSubmit }) {

  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!defaultDeduction) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEmployee("");
    setTotalBalance("");
    setTotalLoan("");
    setDefaultDeduction("");
    setIsActive(false);
    setRemarks("");
    setErrorState(false);
  };
  /* const handleEdit = () =>{
      const data = {
      };

      handleSubmit(data);
  } */

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Edit Loan Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    placeholder="Employee"
                    value={employee}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setEmployee(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Balance</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    type='number'
                    placeholder="Total Balance"
                    value={totalBalance}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setTotalBalance(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Loan</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    type='number'
                    placeholder="Total Loan"
                    value={totalLoan}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setTotalLoan(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Deduction</div>
                <div className="info-item-input">
                  <input
                    type='number'
                    placeholder="Total Deduction"
                    value={defaultDeduction}
                    onChange={(e) => setDefaultDeduction(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !defaultDeduction && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              {!isActive && (
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reason for Deactivation (Remarks)</div>
                  <div className="info-item-input">
                    <input
                      placeholder="e.g., Loan fully paid / Terminated"
                      value={remarks || ""}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !remarks && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please provide a reason for deactivating the loan.
                  </span>
                </div>
              )}
              <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Active?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                EDIT REQUEST
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function OverwriteRequestForm({
  isOpen,
  onClose,
  employee,
  setEmployee,
  totalBalance,
  setTotalBalance,
  totalLoan,
  setTotalLoan,
  defaultDeduction,
  setDefaultDeduction,
  isActive,
  setIsActive,
  handleSubmit }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!totalLoan || !defaultDeduction) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEmployee("");
    setTotalBalance("");
    setTotalLoan("");
    setDefaultDeduction("");
    setIsActive(false);
    setErrorState(false);
  };
  /* const handleOverwrite = () =>{
      const data = {
      };

      handleSubmit(data);
  } */

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Overwrite Loan Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    placeholder="Employee"
                    value={employee}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setEmployee(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Balance</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    type='number'
                    placeholder="Total Balance"
                    value={totalBalance}
                    style={{ cursor: "not-allowed", color: "rgba(0, 0, 0, 0.356)" }}
                    onChange={(e) => setTotalBalance(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Loan</div>
                <div className="info-item-input">
                  <input
                    type='number'
                    placeholder="Total Loan"
                    value={totalLoan}
                    onChange={(e) => setTotalLoan(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !totalLoan && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Total Deduction</div>
                <div className="info-item-input">
                  <input
                    type='number'
                    placeholder="Total Deduction"
                    value={defaultDeduction}
                    onChange={(e) => setDefaultDeduction(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !defaultDeduction && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Active?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                OVERWRITE REQUEST
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, addRequest, editRequest, overwriteRequest, deleteRequest, viewRequest }) {
  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                    ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                    : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => (
                  SetInfo(cell.render("Cell").props.column.Header,
                    cell,
                    addRequest,
                    editRequest,
                    overwriteRequest,
                    deleteRequest,
                    viewRequest)
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) :
        <></>}
    </div>
  )
}
function CreateTableForLoanHistory({ dataList = [], dataHeader = [], dataAccessor = [], addRequest, editRequest, overwriteRequest, deleteRequest, viewRequest }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                    ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                    : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => (
                  SetInfo(cell.render("Cell").props.column.Header,
                    cell,
                    addRequest,
                    editRequest,
                    overwriteRequest,
                    deleteRequest,
                    viewRequest)
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "26px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) :
        <></>}
    </div>
  )
}
function SetInfo(header, _cell, addRequest, editRequest, overwriteRequest, deleteRequest, viewRequest) {
  const data = _cell.render("Cell").props.row.original;

  if (header === "") {
    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <Tooltip text="Add Request">
            <div className='add' style={{ padding: "0 5px", marginRight: "5px" }} onClick={() => addRequest(data)}><AddCardIcon /></div>
          </Tooltip>
          <Tooltip text="Edit">
            <div className='edit' style={{ padding: "0 5px", marginRight: "5px" }} onClick={() => editRequest(data)}><EditNoteIcon /></div>
          </Tooltip>
          <Tooltip text="Recalculate">
            <div className='recycle' style={{ padding: "0 5px", marginRight: "5px" }} onClick={() => overwriteRequest(data)}><RecyclingIcon /></div>
          </Tooltip>
          <Tooltip text="Delete">
            <div className='delete' style={{ padding: "0 5px", marginRight: "5px" }} onClick={() => deleteRequest(data)}><DeleteSweepIcon /></div>
          </Tooltip>
          <Tooltip text="History">
            <div className='history' style={{ padding: "0 5px", marginRight: "5px" }} onClick={() => viewRequest(data)}><PreviewIcon /></div>
          </Tooltip>
        </div>
      </td>
    )
  }

  if (header === "Is Active?") {
    const value = _cell.render("Cell").props.value;

    return (
      <td>
        <input type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={value}
          disabled={true}
        />
      </td>
    )
  }

  if (header === "Manage") {
    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <Tooltip text="History">
            <div className='history' style={{ padding: "0 5px", marginRight: "5px" }} onClick={() => viewRequest(data)}><PreviewIcon /></div>
          </Tooltip>
        </div>
      </td>
    )
  }

  if (header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Total Amount"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === 'number';

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    if (!isNumber) {
      return (
        <td {..._cell.getCellProps()}> {
          _cell.render("Cell")
        }
        </td>
      )
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return (
      <td>
        {formattedNumber}
      </td>
    )
  }

  if (header === "Request Date"
    || header === "Processed Date"
  ) {
    const value = _cell.render("Cell").props.value
    const date = new Date(value);

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return (
      <td>
        {formattedDateFrom}
      </td>
    )
  }

  return (
    <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
  )
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block', zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: 'absolute',
            top: '80%',
            left: '-50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: 'gray',
            padding: '5px',
            borderRadius: '5px',
            pointerEvents: "none",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
function NewRequestConfirmation({ isOpen,
  onClose,
  submit }
) {
  const handleClose = () => {
    onClose();
  };
  const handleSubmit = (e) => {
    handleClose();
    submit(e);
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Do you want to create new requests?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => handleSubmit(e)}
                style={{ marginRight: "5px" }}>
                SAVE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditRequestConfirmation({ isOpen,
  onClose,
  submit }
) {
  const handleClose = () => {
    onClose();
  };

  const handleSubmit = (e) => {
    handleClose();
    submit(e);
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Do you want to save new deduction?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => handleSubmit(e)}
                style={{ marginRight: "5px" }}>
                SAVE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function RecalculateRequestConfirmation({ isOpen,
  onClose,
  submit }
) {
  const handleClose = () => {
    onClose();
  };

  const handleSubmit = (e) => {
    handleClose();
    submit(e);
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Do you want to save the recalculation you made?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => handleSubmit(e)}
                style={{ marginRight: "5px" }}>
                SAVE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function CancelRequestConfirmation({ isOpen,
  onClose,
  submit }
) {
  const handleClose = () => {
    onClose();
  };

  const handleSubmit = (e) => {
    handleClose();
    submit(e);
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Do you want to cancel loan?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => handleSubmit(e)}
                style={{ marginRight: "5px" }}>
                SAVE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function HistoryLoan({ isOpen,
  onClose,
  selectedData }
) {
  var header = [
    "Employee Id",
    "Employee",
    "Processed Date",
    "Total Amount",
    "Status",
    "Remarks",
  ]
  var accessor = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "processedDate",
    "amount",
    "status",
    "remarks",
  ]

  const [loading, setLoading] = useState(false);
  const [loans, setLoans] = useState(false);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/PagibigLoan/loan-logs";

    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/${selectedData.employeePersonalInformationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      console.log(response.data)
      setLoans(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [selectedData]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen]);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Loan History</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div className="users-table container" style={{ overflow: "unset" }}>
                <CreateTableForLoanHistory
                  dataList={loans ? loans : []}
                  dataHeader={header}
                  dataAccessor={accessor}
                />
                {loans.length > 0 ? (
                  <div></div>
                )
                  :
                  (
                    <div>
                      {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                          <img src={loadingSpinner} alt="Loading..." />
                        </div>
                      ) : (
                        <div> {/*<p>No records to display</p>*/}</div>
                      )
                      }
                    </div>
                  )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function InitHistoryLoanTable({ user }) {
  var header = [
    "Pagibig Loan Id",
    "Employee",
    "Total Loan",
    "Total Balance",
    "Default Deduction",
    "Is Active?",
    "Manage",
  ]
  var accessor = [
    "pagibigLoanRequestId",
    "employeePersonalInformationFullName",
    "pagibigLoanRequestTotalLoan",
    "totalBalance",
    "defaultDeduction",
    "isActive",
    "manage"
  ]

  const [loading, setLoading] = useState(false);
  const [loans, setLoans] = useState(false);
  const [historyForm, setHistoryForm] = useState(false);
  const [selectedData, setSelectedData] = useState([]);

  const openHistoryForm = (data) => {
    setSelectedData(data);
    setHistoryForm(true);
  }
  const closeHistoryForm = () => {
    setHistoryForm(false);
  }

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/PagibigLoan";

    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      const finalData = response.data.filter(data => data.employeePersonalInformationId === user.employeePersonalInformationId);
      setLoans(finalData); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <div className="transaction-table container">
        <CreateTableForLoanHistory
          dataList={loans ? loans : []}
          dataHeader={header}
          dataAccessor={accessor}
          viewRequest={openHistoryForm}
        />
        {loans.length > 0 ? (
          <div></div>
        )
          :
          (
            <div>
              {loading ? (
                <div
                  style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )
              }
            </div>
          )}
      </div>
      <HistoryLoan isOpen={historyForm}
        onClose={closeHistoryForm}
        selectedData={selectedData}
      >
      </HistoryLoan>
    </>
  );
}
export default PagibigLoan
